{
  "hero": {
    "title": "Зарабатывайте золото, <em>как будто это ваша работа.<br/></em>",
    "subtitle": "Аналитика межреалмового флиппинга для аукциона Retail. Живые данные, поданные как готовые сделки — без необходимости разбирать графики.",
    "ctaPrimary": "Начать бесплатно",
    "ctaSecondary": "Посмотреть в деле",
    "stats": {
      "regions": "Регионы",
      "regionsValue": "EU · US",
      "updated": "Обновление",
      "updatedValue": "Каждый час"
    }
  },
  "toolsSection": {
    "label": "Инструменты",
    "sectionTitle": "Шесть инструментов. Одна цель: золото.",
    "watchDemo": "Смотреть демо",
    "tags": {
      "flippingTool": "Межреалмовый",
      "dropshipTool": "Пустые рынки",
      "realmStats": "Аналитика",
      "tsmListGenerator": "Экспорт TSM",
      "snipeAlerts": "В реальном времени",
      "inventoryAnalysis": "Сканер сумок"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Инструмент флиппинга",
      "description": "Инструмент флиппинга между реалмами, анализирующий лучшие предложения для предмета.",
      "videoTitle": "Инструмент межреалмового флиппинга",
      "features": {
        "0": "Найдите лучшее предложение для предмета на основе актуальных данных.",
        "1": "Выберите конкретные реалмы, на которых хотите покупать и продавать.",
        "2": "Показывает прибыль в золоте между реалмом покупки и продажи.",
        "3": "Рассчитывает % прибыли для среднего значения продажи vs. покупка и продажа vs. покупка.",
        "4": "Показывает точно, в каком реалме/кластере реалмов покупать и на каком продавать.",
        "5": "Фильтры/сортировка для различных типов предметов и ценовых статистик"
      }
    },
    "dropshipTool": {
      "title": "Инструмент дропшипа",
      "description": "Инструмент дропшипа, показывающий какие предметы не выставлены на сервере, чтобы вы могли перепродавать их без конкуренции.",
      "videoTitle": "Инструмент дропшипа",
      "features": {
        "0": "Найдите лучший сервер для продажи без конкуренции",
        "1": "Выберите конкретные реалмы, на которых хотите покупать и продавать.",
        "2": "Показывает прибыль в золоте между реалмом покупки и продажи.",
        "3": "Рассчитывает % прибыли для среднего значения продажи vs. покупка и продажа vs. покупка.",
        "4": "Показывает точно, в каком реалме/кластере реалмов покупать и на каком продавать.",
        "5": "Фильтры/сортировка для различных типов предметов и ценовых статистик"
      }
    },
    "realmStats": {
      "title": "Статистика реалма",
      "description": "Статистическая информация о каждом реалме, ценах и аукционе. Это помогает решить, где покупать и где продавать.",
      "videoTitle": "Статистика реалма",
      "features": {
        "0": "Найдите информацию о ценах на каждом реалме",
        "1": "Посмотрите, какие серверы продают дорого, а какие дёшево"
      }
    },
    "tsmListGenerator": {
      "title": "Генератор списков TSM",
      "description": "Продвинутый инструмент генерации списков TSM для создания пользовательских списков предметов на основе данных.",
      "videoTitle": "Генератор списков TSM",
      "features": {
        "0": "Используйте несколько источников цен для фильтрации лучших предметов",
        "1": "Создайте идеальный список TSM на основе широкого спектра данных.",
        "2": "Экспортируйте свой список TSM одним нажатием."
      }
    },
    "snipeAlerts": {
      "title": "Снайп-оповещения",
      "description": "Получайте уведомление в тот момент, когда недооценённые предметы, питомцы или BoE по уровню появляются на аукционе — раньше всех остальных.",
      "videoTitle": "Превью снайп-оповещений",
      "features": {
        "0": "Отслеживайте предметы, боевых питомцев и BoE по уровню ниже вашей целевой цены.",
        "1": "Мгновенные оповещения через Discord-DM или webhook, как только найден снайп.",
        "2": "Настройте пороги по каждому предмету через простой и понятный интерфейс."
      }
    },
    "inventoryAnalysis": {
      "title": "Анализ инвентаря",
      "description": "Вставьте CSV-файл инвентаря аддона FlipQueue, чтобы мгновенно увидеть, какие предметы выгодно перепродавать между серверами. Используйте результат в аддоне для размещения на лучших серверах.",
      "videoTitle": "Анализ инвентаря",
      "features": {
        "0": "Сопоставьте текущий инвентарь с актуальными межреалмовыми ценами.",
        "1": "Мгновенно увидьте, какие предметы в сумках выгодно перепродать."
      }
    }
  },
  "edge": {
    "label": "Преимущество",
    "sectionTitle": "Почему участники продлевают подписку.",
    "items": {
      "0": {
        "title": "Больше золота.",
        "body": "Мы показываем флипы с самой высокой маржой на минуту усилий. Ваш показатель «золото в час» — это число, которое мы оптимизируем."
      },
      "1": {
        "title": "Верните свои вечера.",
        "body": "Часы TSM-сканирований сводятся к одному запрашиваемому интерфейсу. Фильтровать, сортировать, выгрузить TSM-список — готово."
      },
      "2": {
        "title": "Начните сегодня вечером.",
        "body": "Никаких таблиц и громоздких аддонов. Большинство участников делают первый прибыльный флип в первый же день."
      }
    }
  },
  "reviews": {
    "label": "Отзывы",
    "sectionTitle": "Что говорят наши участники.",
    "videoTitle": "Отзывы участников FlippingPal"
  },
  "pricing": {
    "label": "Подписка",
    "sectionTitle": "Одна подписка. Все инструменты.",
    "subtitle": "Подписка открывает доступ ко всем инструментам Flipping Pal"
  },
  "faq": {
    "label": "Вопросы",
    "sectionTitle": "Часто задаваемые вопросы.",
    "items": {
      "0": {
        "question": "Получу ли я доступ ко всем инструментам с месячной подпиской?",
        "answer": "Да, у вас будет полный доступ ко всем инструментам Flipping Pal."
      },
      "1": {
        "question": "В каком регионе WoW это работает?",
        "answer": "И в US (NA), и в EU (Европа)."
      },
      "2": {
        "question": "Могу ли я отменить подписку в любой момент?",
        "answer": "Да, вы можете отменить подписку в любое время. После отмены вы потеряете доступ к инструментам."
      },
      "3": {
        "question": "Какие способы оплаты принимаются?",
        "answer": "Любая дебетовая/кредитная карта."
      },
      "4": {
        "question": "Если у меня возникнут вопросы, получу ли я помощь?",
        "answer": "Да, если у вас есть вопросы — задайте их команде в Discord."
      }
    }
  },
  "modal": {
    "close": "Закрыть"
  },
  "backToTop": "Наверх",
  "footerCta": {
    "joinAsAffiliate": "Стать партнёром",
    "contactUs": "Связаться с нами",
    "discord": "Discord",
    "refundPolicy": "Политика возврата",
    "privacyPolicy": "Политика конфиденциальности",
    "termsAndConditions": "Условия использования",
    "copyright": "© 2026 Flipping Pal - Все права защищены. Автор:",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
